"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var common_1 = require("stremio/common");
var components_1 = require("stremio/components");
var Selector_1 = __importDefault(require("./Selector"));
var Table_1 = __importDefault(require("./Table"));
var List_1 = __importDefault(require("./List"));
var Details_1 = __importDefault(require("./Details"));
var Placeholder_1 = __importDefault(require("./Placeholder"));
var useCalendar_1 = __importDefault(require("./useCalendar"));
var useCalendarDate_1 = __importDefault(require("./useCalendarDate"));
var Calendar_less_1 = __importDefault(require("./Calendar.less"));
var classnames_1 = __importDefault(require("classnames"));
var Calendar = function () {
    var _a = (0, react_router_1.useParams)(), year = _a.year, month = _a.month;
    var urlParams = react_1.default.useMemo(function () { return ({
        year: year,
        month: month
    }); }, [year, month]);
    var calendar = (0, useCalendar_1.default)(urlParams);
    var profile = (0, common_1.useProfile)();
    var toDayMonth = (0, useCalendarDate_1.default)(profile).toDayMonth;
    var _b = (0, react_1.useState)(null), selected = _b[0], setSelected = _b[1];
    var detailsTitle = (0, react_1.useMemo)(function () { return toDayMonth(selected); }, [selected, toDayMonth]);
    var loading = calendar.metaItems.some(function (_a) {
        var type = _a.type;
        return type === 'Loading';
    });
    var onDetailsClose = function () {
        setSelected(null);
    };
    return (react_1.default.createElement(components_1.MainNavBars, { className: Calendar_less_1.default['calendar'], route: 'calendar' }, profile.auth !== null ?
        react_1.default.createElement("div", { className: (0, classnames_1.default)(Calendar_less_1.default['content'], 'animation-fade-in') },
            react_1.default.createElement("div", { className: Calendar_less_1.default['main'] },
                react_1.default.createElement(Selector_1.default, { selected: calendar.selected, selectable: calendar.selectable, profile: profile }),
                react_1.default.createElement(Table_1.default, { items: calendar.items, selected: selected, monthInfo: calendar.monthInfo, onChange: setSelected })),
            react_1.default.createElement(List_1.default, { items: calendar.items, loading: loading, selected: selected, monthInfo: calendar.monthInfo, profile: profile, onChange: setSelected }),
            react_1.default.createElement(components_1.BottomSheet, { title: detailsTitle, show: !!selected, onCloseRequest: onDetailsClose },
                react_1.default.createElement(Details_1.default, { selected: selected, items: calendar.items })))
        :
            react_1.default.createElement(Placeholder_1.default, null)));
};
var CalendarFallback = function () { return (react_1.default.createElement(components_1.MainNavBars, { className: Calendar_less_1.default['calendar'] })); };
exports.default = (0, common_1.withCoreSuspender)(Calendar, CalendarFallback);
